// extracted by mini-css-extract-plugin
export default {"collapsible":"daily-report-collapsible_collapsible__-WffD","header":"daily-report-collapsible_header__zs-CB","content":"daily-report-collapsible_content__s579L"};